// @vendors
import { useCallback, useMemo, useState } from 'react'
import { useSelector } from 'react-redux';

// @context
import { useUI } from '../../../app/context/ui';

// @services
import CompanyServiceNewApi from '../../../services/newApi/CompanyServiceNewApi';

// @helpers
import AppHelper from '../../../helpers/AppHelper';
import StatsServiceNewApi from '../../../services/newApi/StatsServiceNewApi';

const useAdmin = () => {
  const { blockUI, snackbarUI } = useUI();
  const companySNewApi = useMemo(() => new CompanyServiceNewApi(), []);
  const statsServicesNewApi = useMemo(() => new StatsServiceNewApi(), []);
  const state = useSelector((loadedState) => loadedState);
  const organizationId = state?.organizationReducer?.organizationSelected?.id;
  const [sortModel, setSortModel] = useState([]);

  const [rowsState, setRowsState] = useState({
      pageSize: 10,
      rows: [],
      rowCount: 0,
      currentPage: 0,
      page: 0,
      filters: { name: '', status: '' },
      sortBy: {hasOrder: null, orderBy:null}
  });

  const [statsToggle, setStatsToggle] = useState({
    employees: 0,
    employers: 0,
    missingEmployeeData: 0,
    completedSurveys: 0,
  });

  const successRequestCompanies = (response) => {
    blockUI.current.open(false);
    const data = response?.data;
    setRowsState((prev) => ({
        ...prev,
        pageSize: data?.pagination?.page_size || 10,
        rows: data?.data || [],
        rowCount: data?.pagination?.total_records || 0,
        currentPage: data?.pagination?.page_number,
        page: data?.pagination?.page_number -1,
    }));
  }

  const getAllCompanies = useCallback(async (params) => {
      const pagination = {page: params?.page ?? 1, size: params?.size ?? rowsState.pageSize}
      const filters = params?.filters || rowsState.filters;
      const sort = {order: params?.order ?? rowsState?.sortBy?.hasOrder, direction: params?.orderBy ?? rowsState?.sortBy?.orderBy }
      try {
          blockUI.current.open(true);
          const response = await companySNewApi.getCompanies(pagination, organizationId, filters, sort)
          setSortModel(params?.sort)
          successRequestCompanies(response)
      } catch (error) {
          blockUI.current.open(false);
          AppHelper.checkError(error, snackbarUI);
      }finally {blockUI.current.open(false)}
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [organizationId, rowsState, companySNewApi, blockUI, snackbarUI]);

  const getStatsToggle = useCallback(async () => {
    try {
      blockUI.current.open(true);
      const [r1, r2, r3] = await Promise.all([
        statsServicesNewApi.getStatsToggle(organizationId),
        statsServicesNewApi.getMissingEmployeeData(organizationId),
        statsServicesNewApi.getStatsCompletedLastMonth(organizationId, 30),
      ]);
      setStatsToggle({
        employees: r1?.data?.data?.employees,
        employers: r1?.data?.data?.employers,
        missingEmployeeData: r2?.data?.data,
        completedSurveys: r3?.data?.data,
      });
      blockUI.current.open(false);
    } catch (error) {
      blockUI.current.open(false);
      AppHelper.checkError(error, snackbarUI);
    }
  }, [organizationId, statsServicesNewApi, snackbarUI, blockUI]);

  return {
    rowsState,
    getAllCompanies,
    setRowsState,
    sortModel,
    getStatsToggle,
    statsToggle,
  }
}

export default useAdmin